// Default environment configuration
export const environment = {
  production: false,
 
    apiUrl: 'https://loadbalancer.messagefromheaven.com/api',
  //  paymentUrl: 'https://abigelai-backend-payment.dev-0d4.workers.dev/api',
    paymentUrl: 'https://fwkezia7zwaxv5p3qo54ax6gym0uoopc.lambda-url.eu-central-1.on.aws/api',

  //  for local development
  // apiUrl: 'http://localhost:4000/api',
  //  paymentUrl: 'http://localhost:3001/api',
 
  // stripePublicKey: 'pk_test_51S3eZiJWDjqWvLZDqpEfgfNkQ4klj3VJTW938LDdvndtiNKO5DGa2gbs9XwXDtHf8WIw92Oqzqd8gFOMN9CyMSyM0094AhIFta'
  stripePublicKey: 'pk_test_51S3eZiJWDjqWvLZDqpEfgfNkQ4klj3VJTW938LDdvndtiNKO5DGa2gbs9XwXDtHf8WIw92Oqzqd8gFOMN9CyMSyM0094AhIFta'
};
